import Chip from "@/components/Chip";
import { AppsListRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  content: string;
  isChecked: boolean;
  subCategoryCount: number;
}

function Heading({ content, isChecked, subCategoryCount }: HeadingProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 px-6 pb-6 pt-8 border-y bg-white">
      <div>
        <span className="text-2xl font-bold mr-2">{content}</span>
        {isChecked ? (
          <Chip label={t("checked")} />
        ) : (
          <Chip variant="info" label={t("not-checked")} />
        )}
      </div>
      <div>
        <AppsListRegular className="mr-2" />
        <span>
          {subCategoryCount} {t("sub-categories")}
        </span>
      </div>
    </div>
  );
}

export default Heading;
